﻿import {CreaturesBankItem} from "../CreaturesBankItem";
import {Core} from "../../Base/Core";
import {Scrollbox} from "pixi-scrollbox";
import {UICommonPopup} from "../Tools/Base/UICommonPopup";

export class UICreatures extends UICommonPopup {
    Awake() {
        super.Awake({
            masked: true,
            title: Core.Localizator.Get("monsters"),
            closeButton: true,
        });

        this.scrollbox = this.content.addChild(new Scrollbox({
            overflow: "hidden",
            interaction: Core.app.renderer.plugins.interaction,
        }));

        this.items = []; // List<CreaturesBankItem>
        this.itemsByCreature = new Map(); // Dictionary<int, CreaturesBankItem>
    }

    Init() {
        super.Init();

        this.items = []; //new List<CreaturesBankItem>();
        this.itemsByCreature = new Map(); //Dictionary<int, CreaturesBankItem>();

        for (let c of Core.GameData.Creatures.creatures) {
            let newItem = this.scrollbox.content.addChild(new CreaturesBankItem());
            newItem.Init(c.id);
            this.items.push(newItem);
            this.itemsByCreature.set(c.id, newItem);
        }
    }

    fitLayout(viewport = Core.app.viewport) {
        let sideRatio = 1.7;
        let w = Math.min(viewport.width * 0.85, (viewport.height * 0.85) / sideRatio);
        let h = w * sideRatio;

        this.setPopupRect(new PIXI.Rectangle((viewport.width - w) * 0.5, (viewport.height - h) * 0.5, w, h));

        super.fitLayout(viewport);

        let popupRect = this.getContentSize();

        let headerRect = new PIXI.Rectangle(this.header.x, this.header.y, this.header.width, this.header.height);
        let padding = w * 0.02;

        let activeItems = this.items.filter(item => item.Active);
        let itemRect = new PIXI.Rectangle(0, padding, popupRect.width - padding * 2, popupRect.height * 0.166);
        for (let item of activeItems) {
            item.fitLayout(itemRect);
            itemRect.y += itemRect.height + padding;
        }

        this.scrollbox.position.set(padding, headerRect.height);
        this.scrollbox.resize({
            boxWidth: itemRect.width,
            boxHeight: popupRect.height - headerRect.height,
            scrollWidth: itemRect.width,
            scrollHeight: itemRect.height * activeItems.length + padding * (activeItems.length + 1),
        });
    }

    Show() {
        Core.Player.PlanetsSave.TutorSave.creatures = true;
        this.fitLayout();
        this.UpdateButtons();
        for (let item of this.items) {
            if (item.activeInHierarchy) {
                item.updateData();
            }
        }
        super.Show();
    }

    UpdateButtons() {
        if (Core.Player.PlanetsSave.CurrentPlanet == null) return;

        let availableCreatures = Core.Player.PlanetsSave.CurrentPlanet.GetAvailableForPurchaseCreatures();

        for (let item of this.items) {
            let hasCreatureInCollection = availableCreatures.includes(item.creatureData.id);
            item.SetActive(hasCreatureInCollection);
            item.SetAdsButtonActive(false);
        }

        for (let i = this.items.length - 1; i >= 0; i--) {
            if (this.items[i].activeInHierarchy) {
                this.items[i].SetAdsButtonActive(true);
                break;
            }
        }

        if (Core.Player.PlanetsSave.TutorSave.step === 5) {
            if (this.items[0] && this.items[0].Active) {
                Core.UI.tutorial.ShowObjectHand(this.items[0].softBtn, this);
            }
        }
    }

    Hide() {
        if (this.Active) {
            Core.Ads.TriggerInterstitial();
        }
        this.scrollbox.scrollTop = 0;
        super.Hide();
    }
}
